import { QueryClient } from "@tanstack/react-query";

import { APP_QUERY_DEFAULTS } from "@/lib/react-query/defaults";

export function createAppQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: APP_QUERY_DEFAULTS,
  });
}
